import React from "react";
import DashboardMenu from "../Layout/menu";

const Layout = ({ children }) => {
  return (
    <div className="font-Roboto">
      <DashboardMenu />

      {children}
    </div>
  );
};

export default Layout;
